// extracted by mini-css-extract-plugin
export default {"avatar":"menuBlock_avatar__Wqoth","loginName":"menuBlock_loginName__rcjd1","btnWrapper":"menuBlock_btnWrapper__ztfR2","btn":"menuBlock_btn__FafDt"};